import React from 'react';
import { motion } from 'framer-motion';
type Props = {
  children: React.ReactNode;
  className?: string;
  borderRadius?: string;
  duration?: number;
  intensity?: 'subtle' | 'medium' | 'bright';
};
export const GlowBorder: React.FC<Props> = ({
  children,
  className = '',
  borderRadius = 'rounded-2xl',
  duration = 8,
  intensity = 'medium'
}) => {
  const intensityMap = {
    subtle: {
      main: 0.5,
      secondary: 0.3,
      base: 0.12
    },
    medium: {
      main: 0.8,
      secondary: 0.6,
      base: 0.2
    },
    bright: {
      main: 1,
      secondary: 0.8,
      base: 0.3
    }
  };
  const {
    main,
    secondary,
    base
  } = intensityMap[intensity];
  return <div className={`relative p-[2px] overflow-hidden ${borderRadius} ${className}`} data-id="element-46">
      {/* Rotating light */}
      <motion.div className={`absolute inset-0 ${borderRadius}`} animate={{
      rotate: 360
    }} transition={{
      duration,
      repeat: Infinity,
      ease: 'linear'
    }} style={{
      background: `conic-gradient(from 0deg, transparent 0%, rgba(212,175,122,${main}) 10%, transparent 20%, transparent 50%, rgba(229,200,150,${secondary}) 60%, transparent 70%, transparent 100%)`
    }} data-id="element-47" />
      {/* Static base border */}
      <div className={`absolute inset-0 ${borderRadius}`} style={{
      background: `linear-gradient(135deg, rgba(212,175,122,${base}), rgba(212,175,122,${base * 0.3}) 50%, rgba(212,175,122,${base * 0.9}))`
    }} data-id="element-48" />
      {/* Content */}
      <div className={`relative ${borderRadius}`} data-id="element-49">{children}</div>
    </div>;
};